import React, { CSSProperties } from 'react';
import { Box, Typography } from '@mui/material';
import emptyScheduleIcon from '../../utils/assets/empty_schedule.svg';
import { useEmptyScheduleStyles } from './styles';
import CustomButton from '../CustomButton';

interface IProps {
  emptyText: string;
  handleClick: () => void;
}

const EmptySchedule = ({ emptyText, handleClick }: IProps) => {
  const emptyScheduleStyles = useEmptyScheduleStyles();

  return (
    <Box sx={emptyScheduleStyles.wrapper}>
      <img
        style={emptyScheduleStyles.icon as CSSProperties}
        src={emptyScheduleIcon}
        alt="Empty list"
      />
      <Typography sx={emptyScheduleStyles.text}>{emptyText}</Typography>
      <CustomButton
        style={emptyScheduleStyles.button}
        handleClick={handleClick}>
        Book a Session
      </CustomButton>
    </Box>
  );
};

export default EmptySchedule;
